import { Box } from 'ui';

export const TiltOverlay = ({ isCameraLevel }: { isCameraLevel: boolean }) => {
  return <Box width="100%" height="100%" sx={{ border: '4px solid', borderColor: isCameraLevel ? 'green' : 'red' }} />;
};
